import React from 'react'
import styled from 'styled-components'


const Wrapper = styled.section`
.section{
  padding-top: 10%;
  padding-bottom: 5%;
}
img{
  width: 90%;
  display: flex;
  margin: 0 auto;
}
h2{
  color:#EC632F;
  margin-top: 5%;
  margin-left:21px;
}
.first-p{
  color: #909090;
  margin-left:21px;
  margin-right: 25px;
line-height: 1.5;
margin-bottom: 6%;
margin-top: 3%;
}
.second-p{
  display: none;
}
.third-p{
  display: none;
}
button{
  border: none;
  color: #fff;
  border-radius: 4%;
  background: #EC632F;
  margin-left: 23px;
  height: 42px;
  font-size: 18px;
  width: 140px;
}


@media (min-width: 768px) {
  .section{
    display: flex;
    margin: 0 20px;
    gap: 10px;

  } 
  img{
  width: 50%;
  display: flex;
  margin: 0 ;
}
}


@media (min-width: 992px) {
  img{
  width: 50%;
  height: 380px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}

.section{
    display: flex;
    margin: 0 40px;
    gap: 10px;

  } 
.first-p{
  color: #909090;
  margin-left:21px;
  margin-right: 25px;
line-height: 1.5;
margin-bottom: 10%;
margin-top: 5%;
}
}


@media (min-width: 1200px) {

  .section{
    display: flex;
    margin: 0 90px;
    gap: 90px;

  } 
.inner-div{
  display: flex;
  flex-direction: column;
  /* align-items: center; */
/* justify-content: center; */
  background: none;
  width: 82%;
  height: 90%;
}
  .text-div{
    border-radius: 3%;
display: flex;
justify-content: center;
align-items: center;
border-left:1px solid green;
border-right: 1px solid green;
border-bottom: 1px solid green;
    background: none;
  }
  img{
    border-radius: 2%;
  width: 43%;
  height:600px;
  object-fit: cover;
  display: flex;
  margin: 0 ;
}
h2{
  font-size: 33px;
  font-weight: 600;
  color:#EC632F;
  margin-top: 7%;
  margin-left:0px;
}
.first-p{
  color: #909090;
  margin-left:0px;
  margin-right: 10px;
line-height: 1.2;
font-size: 17px;
margin-bottom:0%;
margin-top: 6%;
}
.second-p{
  color: #909090;
  display: block;
  margin-right: 10px;
  line-height: 1.2;
  font-size: 17px;

}
.third-p{
  color: #909090;
  display: block;
  margin-right: 10px;
  line-height: 1.2;
  font-size: 17px;
  margin-bottom: 5%;
margin-top: 5%;
}

button{
  border: none;
  color: #fff;
  border-radius: 5%;
  background: #EC632F;
  margin-left: 0px;
  height: 40px;
  font-size: 18px;
  width: 145px;
}
}
`
function About() {
  return (
    <Wrapper>
      <div className='section'>
      <img src="./photos/manykids.png" alt=""/>
         <div className='text-div'>
          <div className='inner-div'>
         <h2>About Us</h2>
          <p  className='first-p'>At Favour, we believe that childhood is the perfect time to nurture young minds and help them embark on a magical journey towards a dazzling future. In our sun-soaked classrooms, children are encouraged to ask questions, create art and explore science. Our passionate teachers believe that play is the key to unlock the potential of each child, helping them to overcome obstacles and build confidence.... </p>
          <p className='second-p'>We are dedicated to providing a safe and supportive environment where children can learn and grow, and where they can develop skills that will help them succeed in life. With every step they take, from building towers of blocks to mastering language and science, we help them to become confident, curious and creative individuals. </p>
          <p className='third-p'>Join us at Favour and discover how playful days can become the first chapter of extraordinary lives. Our commitment to laughter, wonder and exploration will help your child reach new heights and soar towards a bright future.</p>
           <button>Learn More</button>
           </div>
         </div>
      </div>
    </Wrapper>
  )
}

export default About
